<script>
	import { convert } from "src/services/helpers";
	import { Col, Row } from "@sveltestrap/sveltestrap";
	import DamageInformationDisplayDesmond from "./DamageInformationDisplayDesmond.svelte";
	import { isCXTSRole, isPhase3CaseOrigin } from "src/utils/misc";
	import DamageInformationVqp from "./DamageInformationVqp.svelte";

	export let caseDetails = {};
	export let incidentDateTime;
	export let form;
	export let state = "view"; // possible values: "view", "edit", "create"
	export let damageCauseType;
	export let attribution;
	export let damageCause;
	export let staffName;
	export let staffContact;
	export let thirdPartyName;
	export let thirdPartyContact;
	export let vqp;
	export let l1Remarks;
</script>

{#if caseDetails.createdFrom === "Desmond"}
	<DamageInformationDisplayDesmond
		{caseDetails}
		{incidentDateTime}
		{form}
		{state}
		{damageCauseType}
		{attribution}
		{damageCause}
		{staffName}
		{staffContact}
		{thirdPartyName}
		{thirdPartyContact}
		{vqp}
		{l1Remarks}
	/>
{:else}
	<div class="p-0">
		<Row>
			<Col>
				<div class="description">Incident Date Time</div>
				<div class="value">{convert(caseDetails.incidentDateTime)}</div>
			</Col>

			<Col>
				<div class="description">Attributed To</div>
				<div class="value">{caseDetails.attribution}</div>
			</Col>

			<Col>
				{#if caseDetails.attribution === "User"}
					<div class="description">Booking Id</div>
					<div class="value">{caseDetails.bookingNo || "-"}</div>
				{:else if caseDetails.attribution === "Staff"}
					<div class="description">Staff Name</div>
					<div class="value">{caseDetails.staffName || "-"}</div>
				{:else if caseDetails.attribution === "ThirdParty"}
					<div class="description">Third Party Name</div>
					<div class="value">{caseDetails.thirdPartyName || "-"}</div>
				{/if}
			</Col>
		</Row>
		<hr class="divider" />
		<Row>
			{#if caseDetails.attribution === "Staff"}
				<Col>
					<div class="description">Staff Contact No</div>
					<div class="value">{caseDetails.staffContact || "-"}</div>
				</Col>
			{:else if caseDetails.attribution === "ThirdParty"}
				<Col>
					<div class="description">Third Party Contact No</div>
					<div class="value">
						{caseDetails.thirdPartyContact || "-"}
					</div>
				</Col>
			{/if}
			<Col>
				<div class="description">Type of Collision</div>
				<div class="value">{caseDetails.collisionType}</div>
			</Col>
			<Col>
				<div class="description">Actual Booking Start Time</div>
				<div class="value">{convert(caseDetails.bookingStartTime)}</div>
			</Col>
			<Col>
				<div class="description">Actual Booking End Time</div>
				<div class="value">{convert(caseDetails.bookingEndTime)}</div>
			</Col>
		</Row>
		<hr class="divider" />
		<Row>
			<Col>
				{#if caseDetails.status === "Quoting"}
					<div>
						<DamageInformationVqp {vqp} {caseDetails} />
					</div>
				{:else}
					<div class="description">VQP</div>
					<div class="value">{caseDetails.vqp ?? "-"}</div>
				{/if}
			</Col>
		</Row>
		<hr class="divider" />
		<Row>
			{#if isCXTSRole(caseDetails.createdFrom)}
				<Col>
					<div class="description">CX Remarks</div>
					<div class="value">{caseDetails.cxRemarks || "-"}</div>
				</Col>
			{/if}
			{#if isPhase3CaseOrigin(caseDetails.createdFrom)}
				<Col>
					<div class="description">L1 Remarks</div>
					<div class="value">{caseDetails.l1Remarks || "-"}</div>
				</Col>
			{/if}
		</Row>
	</div>
{/if}
